var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4444 16H3.55556C2.69645 16 2 15.3036 2 14.4444V3.55556C2 2.69645 2.69645 2 3.55556 2H14.4444C15.3036 2 16 2.69645 16 3.55556V14.4444C16 15.3036 15.3036 16 14.4444 16ZM11.978 14.0556H14.0556V9.78774C14.0556 7.98198 13.0319 7.10888 11.6022 7.10888C10.1717 7.10888 9.56974 8.22279 9.56974 8.22279V7.31481H7.56759V14.0556H9.56974V10.5171C9.56974 9.56897 10.0062 9.00477 10.8415 9.00477C11.6094 9.00477 11.978 9.54692 11.978 10.5171V14.0556ZM3.94444 5.18831C3.94444 5.87521 4.49707 6.43217 5.17904 6.43217C5.86101 6.43217 6.41331 5.87521 6.41331 5.18831C6.41331 4.5014 5.86101 3.94444 5.17904 3.94444C4.49707 3.94444 3.94444 4.5014 3.94444 5.18831ZM6.23294 14.0556H4.14522V7.31481H6.23294V14.0556Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.069c53e8578ed249e996459583815276.svg";
export { ForwardRef as ReactComponent };